module.exports = __webpack_public_path__ + "static/img/102_TO8_1784.972a522.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/102_TO8_1784.jpg
// module id = aM6c
// module chunks = 0